<template>
  <v-container fill-height fluid grid-list-xl>
    <material-card
      color="green"
      flat
      full-width
      title="Подарки к заказу"
    >
      <v-dialog v-model="editDialog">
        <template #activator="{ on, attrs }">
          <v-btn
            color="red"
            dark
            class="mb-2"
            v-bind="attrs"
            v-on="on"
          >
            Новый подарок
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Редактирование подарка</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col sm="12">
                <v-text-field
                  v-model="editedItem.orderSumTotal"
                  label="Сумма заказа"
                />
                <v-card>
                  <v-card-title>Сопутствующие товары</v-card-title>
                  <v-card-text>
                    <relations :open-dialog="dialog" :default="offersFormatted" @change="val => selectedOffers = val" />
                  </v-card-text>
                </v-card>
                <v-select
                  v-model="editedItem.status"
                  :items="statusList"
                  label="Статус"
                  single-line
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text @click="closeEdit">
              Отмена
            </v-btn>
            <v-btn color="blue darken-1" text @click="save">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-data-table
        :loading="$apollo.loading"
        loading-text="Загрузка..."
        :headers="headers"
        :items="data"
        :server-items-length="totalCount"
        :options.sync="options"
      >
        <template #item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-dialog
            transition="dialog-bottom-transition"
            width="500"
            :value="deleteDialog === item.id"
            @input="toggleDeleteDialog($event, item.id)"
          >
            <template #activator="{ on, attrs }">
              <v-tooltip top>
                <template #activator="{ on: tooltipActions, attrs: tooltipAttrs }">
                  <span v-bind="tooltipAttrs" v-on="tooltipActions">
                    <v-icon tag="i" v-bind="attrs" small class="mr-2" v-on="on">
                      mdi-delete
                    </v-icon>
                  </span>
                </template>
                Удалить
              </v-tooltip>
            </template>
            <v-card>
              <v-toolbar color="primary" dark class="text-center mb-6">
                Подтвердите Действие
              </v-toolbar>
              <v-card-text>
                Вы точно хотите удалить запись?
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn color="tertiary" dark @click="deleteDialog = null">
                  Отменить
                </v-btn>
                <v-btn color="primary" @click="deleteItem(item.id)">
                  Удалить
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template #item.status="{ item }">
          {{ getStatus(item) }}
        </template>
        <template #item.offers="{ item }">
          <span v-for="offer in item.offer" :key="offer.id">
            {{ offer.id }} {{ offer.name }} <br />
          </span>
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>

<script>
import { createGift, deleteGift, getGifts, updateGift } from '@/graphql/order-gifts'
import { startCase } from 'lodash-es'
import Relations from '@/components/press/relations'

export default {
  name: 'OrderGiftsList',
  components: {
    Relations
  },
  layout: 'dashboard',
  apollo: {
    gifts: {
      query: getGifts,
      variables () {
        const filter = {}
        if (this.filterStatus) {
          filter.status = this.filterStatus
        }
        if (this.filterType) {
          filter.type = this.filterType
        }
        return {
          filter,
          limit: this.options.itemsPerPage,
          offset: this.options.itemsPerPage * (this.options.page - 1)
        }
      },
      result ({ data }) {
        if (data?.gifts?.data) {
          this.data = data.gifts.data
          this.totalCount = data.gifts.totalCount
        }
      },
      update: data => data?.gifts?.data
    }
  },
  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        multiSort: false
      },
      totalCount: 0,
      deleteDialog: false,
      dialog: false,
      editDialog: false,
      newItem: true,
      filter: [],
      filterName: '',
      filterType: '',
      filterStatus: 'ACTIVE',
      editedItem: {},
      selectedOffers: [],
      data: [],
      statusList: [
        { value: 'ACTIVE', text: 'Активно' },
        { value: 'NOT_ACTIVE', text: 'Не активно' }
      ],
      headers: [
        ['id', 'Id'],
        ['offers', 'Товары'],
        ['orderSumTotal', 'Сумма заказа'],
        ['status', 'Статус'],
        ['actions', null]
      ]
          .map((colTitle) => {
            const [value, text] = Array.isArray(colTitle)
                ? colTitle
                : [colTitle, startCase(colTitle)]

            return {
              value,
              text,
              sortable: false
            }
          }),
      rules: {
        required: value => !!value || 'Обязательное поле.'
      }
    }
  },
  computed: {
    offersFormatted () {
      return this?.editedItem?.offer?.map(offer => offer.id)
    }
  },
  watch: {
    dialog (val) {
      if (!val) {
        if (this.newItem) {
          this.editedItem = Object.assign({})
        }
      } else {
        this.newItem = true
      }
    },
    editDialog (val) {
      if (val) {
        if (this.newItem) {
          this.editedItem = Object.assign({})
        } else {
          this.selectedOffers = this?.editedItem?.offer?.map(offer => offer.id)
        }
      } else {
        this.newItem = true
      }
    }
  },
  methods: {
    getStatus (item) {
      const ret = this.statusList.filter(row => row.value === item.status)
      if (ret.length > 0) {
        return ret[0].text
      }

      return item.status
    },
    toggleDeleteDialog (value, slug) {
      this.deleteDialog = value
          ? slug
          : null
    },
    save () {
      const saveData = {
        orderSumTotal: parseInt(this.editedItem.orderSumTotal ?? 0),
        offerId: this?.selectedOffers ?? [],
        status: this.editedItem.status
      }
      if (this.newItem) {
        this.$apollo
            .mutate({
              mutation: createGift,
              variables: {
                input: saveData
              }
            })
            .then((data) => {
              this.reFetchQuery()
            })
            .catch((error) => {
              console.error(error)
            })
      } else {
        const id = this.editedItem.id
        this.$apollo
            .mutate({
              mutation: updateGift,
              variables: {
                id,
                input: saveData
              }
            })
            .then((data) => {
              this.reFetchQuery()
            })
            .catch((error) => {
              console.error(error)
            })
      }
      this.closeEdit()
      this.editedItem = []
    },
    deleteItem (id) {
      this.$apollo
          .mutate({
            mutation: deleteGift,
            variables: {
              id
            }
          })
          .then((data) => {
            this.reFetchQuery()
            this.deleteDialog = null
          })
          .catch((error) => {
            console.error(error)
          })
    },
    editItem (item) {
      this.newItem = false
      this.editedItem = Object.assign({}, item)
      this.editDialog = true
    },
    close () {
      this.dialog = false
    },
    closeEdit () {
      this.editDialog = false
    },
    formatDate (timestamp) {
      const date = new Date(timestamp)
      return date.form
    },
    reFetchQuery () {
      this.$apollo.queries.gifts.refetch()
    }
  }
}
</script>

<style scoped>

</style>
